var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('p',{staticClass:"me-1"},[_vm._v(_vm._s(_vm.params.value.name))]),_c('p',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(
      `เบอร์โทร ${_vm.params.value.phone}
      อีเมล ${_vm.params.value.email}`
    ),expression:"\n      `เบอร์โทร ${params.value.phone}\n      อีเมล ${params.value.email}`\n    "}],staticClass:"text-primary"},[_vm._v(" (i) ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }